import { CreateSegmentIntegrationModal } from './CreateSegmentIntegrationModal';
import { EditSegmentIntegrationModal } from './EditSegmentIntegrationModal';
import { DeleteThirdPartyIntegrationModal } from './DeleteThirdPartyIntegrationModal';
import { useModalsContext, MODAL_ACTION, ThirdPartyIntegrationFormProvider } from '../contexts';

const ModalsByAction = {
  [MODAL_ACTION.CREATE_THIRD_PARTY_INTEGRATION]: CreateSegmentIntegrationModal,
  [MODAL_ACTION.EDIT_THIRD_PARTY_INTEGRATION]: EditSegmentIntegrationModal,
  [MODAL_ACTION.DELETE_THIRD_PARTY_INTEGRATION]: DeleteThirdPartyIntegrationModal,
};

export const ModernizedModals = () => {
  const { modalState } = useModalsContext();

  if (modalState === null) return null;

  const Modal = ModalsByAction[modalState.action];
  const { thirdPartyIntegration } = modalState;

  return (
    <ThirdPartyIntegrationFormProvider initialValues={thirdPartyIntegration}>
      <Modal />
    </ThirdPartyIntegrationFormProvider>
  );
};
